import {computed, Directive, input} from "@angular/core";
import type {BootstrapIconsId} from "bootstrap-icons";
import {bootstrapIconClass} from "../helpers/BootstrapIconClass";

@Directive({
  selector: "[rfBsIcon]",
  host: {
    "class": "bi",
    "[class]": "iconClass()",
  },
})
export class BootstrapIcon {
  public readonly iconId = input.required<BootstrapIconsId>({alias: "rfBsIcon"});

  protected readonly iconClass = computed(() => bootstrapIconClass(this.iconId()));
}
